class ProposalDecisionNotify {
  static getEmailData = (dst, user, project, decision) => {
    const from = `Gobierno de El Salvador <info@goes.gob.sv>`;

    const to = dst;
    const subject = `Decisión sobre tu propuesta de proyecto`;
    const body = templateData(user, project, decision);

    return {
      from,
      to,
      subject,
      body
    };
  };
}

export default ProposalDecisionNotify;

const templateData = (user, project, decision) => {
  const decisionText = decision === 'approved' ? 'aprobada' : 'rechazada';

  const generateCommentsTable = () => {
    const comments = project.comments || [];

    if (comments.length === 0) {
      return '<p>No hay comentarios.</p>';
    }

    let tableRows = comments
      .map((comment) => {
        return `
        <tr>
          <td>${comment.user.displayName}</td>
          <td>${comment.text}</td>
          <td>${comment.type}</td>
          <td>${comment.createAt}</td>
        </tr>
      `;
      })
      .join('');

    return `
      <table style="width:100%; border-collapse: collapse;">
        <thead>
          <tr>
            <th>Usuario</th>
            <th>Comentario</th>
            <th>Tipo</th>
            <th>Fecha</th>
          </tr>
        </thead>
        <tbody>
          ${tableRows}
        </tbody>
      </table>
    `;
  };

  return `
      <h2 style="text-align: center;">
        Decisión sobre tu propuesta de proyecto
      </h2>
      <br />
      <p>Estimado(a) ${user?.displayName},</p>
      <br />
      <p>
        Queremos informarte que la propuesta de tu proyecto ha sido ${decisionText}. A continuación, se presentan algunos detalles del proyecto:
      </p>
      <br />
      <p> 
        <h3>${project.ministerio}</h3>
        <p><strong>Datos de contacto:</strong> 
          ${user?.email} - ${user?.phoneNumber}
        </p>
        <p><strong>Título:</strong> 
          ${project.title}
        </p>
        <p><strong>Descripción:</strong> 
          ${project.resumenProyecto}
        </p>
      </p>
      <br />
      <p>
      <h3>Comentarios:</h3>
      ${generateCommentsTable()}
      </p>
      <br />
      <p>
        Para obtener más información, visita el Portal y revisa tus notificaciones <a href="${'https://portal.modernizacion.gob.sv'}">aquí</a>.
      </p>
      <br />
      <br />
      <p>Saludos,</p>
      <br />
      <p>Portal de Proyectos Gobierno de El Salvador en Convenio con Google LLC</p>
    `;
};
